import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import Header from './layout-components/header/header';
import Footer from './layout-components/footer/footer';
import KCISThemeRoutes from '../routes_kcis/router';

import {getData,getKCISData} from '../services/index';


import LeftSidebar from './layout-components/header/left_side_bar';

const mapStateToProps = state => ({
	...state
});

class Fulllayout extends React.Component {
	constructor(props) {
		super(props);
		this.updateDimensions = this.updateDimensions.bind(this);
		this.state = {
			is_header: 0,
			isOpen: false,
			erp_type: 'kcis',
			width: window.innerWidth
		};

		this.props.history.listen((location, action) => {
			if (window.innerWidth < 767 &&
				document.getElementById('main-wrapper').className.indexOf("show-sidebar") !== -1) {
				//document.getElementById('main-wrapper').classList.toggle("show-sidebar");
			}
		});
	}
	componentDidMount() {
		window.addEventListener("load", this.updateDimensions);
		window.addEventListener("resize", this.updateDimensions);
		if(localStorage.getItem('schoolData')) {
			this.setState({ is_header : 1 });
			const params = new Proxy(new URLSearchParams(window.location.search), {
			    get: (searchParams, prop) => searchParams.get(prop),
			});
			if(params.t!=null && params.s!=null){
				var app_token = localStorage.getItem("app_token");
				var check_id = localStorage.getItem("erp_id");
				if(params.t != app_token || check_id!=params.s){
					let token = params.t;
					let erp_id = params.s;
					var app = {token:token,erp_id:erp_id}
					var new_id = erp_id.split('_');
					getKCISData('auth/verify_token',app).then((result) => {
						let responseJson = result;
						if(responseJson){
							if(result['status'] == 200){
								localStorage.setItem('schoolData',JSON.stringify(responseJson));
								localStorage.setItem("app_token",params.t);
								var erp_id = result['data'][0]['erp_id'];
								var erp_type = erp_id.split('_');
								localStorage.setItem("erp_id",erp_id);
								localStorage.setItem("erp_type",erp_type[0]);
								window.location.reload(false);
							}
						}
					});
				}
			}
		}else{
			this.setState({ is_header : 0 });
			const params = new Proxy(new URLSearchParams(window.location.search), {
			    get: (searchParams, prop) => searchParams.get(prop),
			 });
			if(params.t!=null && params.s!=null){
				let token = params.t;
				let erp_id = params.s;
				var app = {token:token,erp_id:erp_id}
				var new_id = erp_id.split('_');
				getKCISData('auth/verify_token',app).then((result) => {
					let responseJson = result;
					if(responseJson){
						if(result['status'] == 200){
							localStorage.setItem('schoolData',JSON.stringify(responseJson));
							localStorage.setItem("app_token",params.t);
							var erp_id = result['data'][0]['erp_id'];
							var erp_type = erp_id.split('_');
							localStorage.setItem("erp_id",erp_id);
							localStorage.setItem("erp_type",erp_type[0]);
							window.location.reload(false);
						}
					}
				});
			}
		}
	}
	
	updateDimensions() {
		let element = document.getElementById('main-wrapper');
		this.setState({
			width: window.innerWidth
		});
		switch (this.props.settings.activeSidebarType) {
			case 'full':
			case 'iconbar':
				if (this.state.width < 1170) {
					element.setAttribute("data-sidebartype", "mini-sidebar");
					element.classList.add("mini-sidebar");
				} else {
					element.setAttribute("data-sidebartype", this.props.settings.activeSidebarType);
					element.classList.remove("mini-sidebar");
				}
				break;

			case 'overlay':
				if (this.state.width < 767) {
					element.setAttribute("data-sidebartype", "mini-sidebar");
				} else {
					element.setAttribute("data-sidebartype", this.props.settings.activeSidebarType);
				}
				break;

			default:
		}
	}

	componentWillUnmount() {
		window.removeEventListener("load", this.updateDimensions);
		window.removeEventListener("resize", this.updateDimensions);
	}
	render() {
		return (
			<div class="main-wrapper layout-container" id="main-wrapper">
				{(() => {
					if (this.state.is_header == 0) {
						return (
							<>
							<Switch>
								{KCISThemeRoutes.map((prop, key) => {
									if (prop.navlabel) {
										return null;
									}
									else if (prop.collapse) {
										return prop.child.map((prop2, key2) => {
											if (prop2.collapse) {
												return prop2.subchild.map((prop3, key3) => {
													return (
														<Route path={prop3.path} component={prop3.component} key={key3} />
													);
												});
											}
											return (
												<Route path={prop2.path} component={prop2.component} key={key2} />
											);
										});
									}
									else if (prop.redirect) {
										return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
									}
									else {
										return (
											<Route path={prop.path} component={prop.component} key={key} />
										);
									}
								})}
							</Switch>

							</>
						)
					}else{
						return (
							<>
								<Header />
								<div className="content-wrapper">
									<div className="container-xxl flex-grow-1 container-p-y">
									<Switch>
										{KCISThemeRoutes.map((prop, key) => {
											if (prop.navlabel) {
												return null;
											}
											else if (prop.collapse) {
												return prop.child.map((prop2, key2) => {
													if (prop2.collapse) {
														return prop2.subchild.map((prop3, key3) => {
															return (
																<Route path={prop3.path} component={prop3.component} key={key3} />
															);
														});
													}
													return (
														<Route path={prop2.path} component={prop2.component} key={key2} />
													);
												});
											}
											else if (prop.redirect) {
												return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
											}
											else {
												return (
													<Route path={prop.path} component={prop.component} key={key} />
												);
											}
										})}
									</Switch>
									</div>
									<Footer />
								</div>
							</>
						)
					}
				})()}


			</div>
		);
	}
}
export default connect(mapStateToProps)(Fulllayout);
